import { render, staticRenderFns } from "./Responses.vue?vue&type=template&id=b5e6158c"
import script from "./Responses.vue?vue&type=script&lang=ts"
export * from "./Responses.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports